import { createAction, props } from '@ngrx/store';

import { IResultEnko, IResultUpdatePhoneEnko } from '../../shared/models/Enko.model';

/**
 * * Baja los datos de enko para conexion url
 */
export const getEnko = createAction(
    '[Enko] Data Enko Url',
);

export const successEnko = createAction(
    '[Enko] Data Enko Url Success',
    props<IResultEnko>()
);

export const errorEnko = createAction(
    '[Enko] Data Enko Url Error',
    props<{ payload: Error }>()
);

export const clearEnko = createAction(
    '[Enko] Data Enko Url Ckear'
);

/**
 * * Actualiza telefono del tendero cuando realiza el cambio en perfil, para enko
 */
export const updatePhoneEnko = createAction(
    '[UpdatePhoneEnko] Data Update Phone Enko Url',
    props<{ telefono: string; telefonoPrevio: string }>()
);

export const successUpdatePhoneEnko = createAction(
    '[UpdatePhoneEnko] Data Update Phone Enko Url Success',
    props<IResultUpdatePhoneEnko>()
);

export const errorUpdatePhoneEnko = createAction(
    '[UpdatePhoneEnko] Data Update Phone Enko Url Error',
    props<{ payload: Error }>()
);

export const clearUpdatePhoneEnko = createAction(
    '[UpdatePhoneEnko] Data Update Phone Enko Url Clear'
);
